/** One of the card tags that turns into a 24px icon dot on a phone (P/Member_Hub.html:681-688). */
export type AGUIconDotKind = 'rec' | 'new' | 'visa';

/** A legend entry: the short key text (P/Member_Hub.html:1001) and the dot's own accessible name (:983). */
export interface AGUIconDotLegendEntry {
    readonly Kind: AGUIconDotKind;
    readonly Label: string;
    readonly AriaLabel: string;
}

/** The dots' names, verbatim from the prototype's `tagTitles` (P/Member_Hub.html:983). */
export const ICON_DOT_ARIA_LABELS: Readonly<Record<AGUIconDotKind, string>> = {
    rec: 'Recommended for you',
    new: 'New',
    visa: 'Visa sponsored',
};

/**
 * The one-line key above a phone result list (`.mlegend`, P/Member_Hub.html:694-700, 995-1006): Recommended and New, plus Visa only
 * when a visa tag is on the screen (:1000-1001).
 */
export function IconDotLegend(hasVisa: boolean): readonly AGUIconDotLegendEntry[] {
    const entries: AGUIconDotLegendEntry[] = [
        { Kind: 'rec', Label: 'Recommended', AriaLabel: ICON_DOT_ARIA_LABELS.rec },
        { Kind: 'new', Label: 'New', AriaLabel: ICON_DOT_ARIA_LABELS.new },
    ];
    if (hasVisa) entries.push({ Kind: 'visa', Label: 'Visa', AriaLabel: ICON_DOT_ARIA_LABELS.visa });
    return entries;
}
